<template>
  <div class="user-wrapper">
    <div class="login-page login-page--auth-inputs">
      <div class="title">注册</div>
      <div class="form-list">
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">昵称</div>
          </div>
          <el-input
            v-model="from.username"
            placeholder="请输入昵称"
            type="text"
            class="ipt"
            @blur="testFormItem('username')"
            @keyup.enter="submitFun"
            :disabled="loading"
            maxlength="20"
          />
          <div class="error-box flex flex-align-center" v-if="rule.username">
            <img class="error-icon" src="@/assets/images/error.png" alt="" />
            <div class="msg">{{ rule.username }}</div>
          </div>
        </div>
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">密码</div>
          </div>
          <el-input
            v-model="from.password"
            placeholder="请输入密码（8位以上，含数字和字母）"
            type="password"
            class="ipt"
            @blur="testFormItem('password')"
            @keyup.enter="submitFun"
            :disabled="loading"
            show-password
          />
          <div class="error-box flex flex-align-center" v-if="rule.password">
            <img
              class="error-icon"
              src="../../assets/images/error.png"
              alt=""
            />
            <div class="msg">{{ rule.password }}</div>
          </div>
        </div>
        <div class="form-item">
          <div class="label-box">
            <div class="lable-text">手机号</div>
          </div>
          <el-input
            v-model="from.phone"
            placeholder="请输入手机号"
            type="text"
            class="ipt"
            @blur="testFormItem('phone')"
            @keyup.enter="submitFun"
            :disabled="loading"
            maxlength="11"
          />
          <div class="error-box flex flex-align-center" v-if="rule.phone">
            <img
              class="error-icon"
              src="../../assets/images/error.png"
              alt=""
            />
            <div class="msg">{{ rule.phone }}</div>
          </div>
        </div>
        <div class="line flex">
          <div class="form-item flex1">
            <div class="label-box">
              <div class="lable-text">验证码</div>
            </div>
            <div class="iput-box">
              <el-input
                v-model="from.code"
                type="text"
                class="ipt"
                @blur="testFormItem('code')"
                @keyup.enter="submitFun"
                :disabled="loading"
                placeholder="请输入验证码"
                maxlength="6"
              />
            </div>
          </div>
          <div
            class="form-item code-btn"
            @click="clickCode"
            :class="{ gray: conutdown > 0 || codeLoading }"
            :style="{
              cursor: conutdown > 0 || codeLoading ? 'not-allowed' : 'pointer',
            }"
          >
            {{
              codeLoading
                ? "发送中..."
                : conutdown > 0
                ? `获取(${conutdown})`
                : "获取"
            }}
          </div>
          <div class="error-box flex flex-align-center" v-if="rule.code">
            <img
              class="error-icon"
              src="../../assets/images/error.png"
              alt=""
            />
            <div class="msg">{{ rule.code }}</div>
          </div>
        </div>
      </div>
      <div class="argee flex flex-align-center">
        <el-checkbox class="check" v-model="isCheck" label="" size="large" />
        <span class="read">我已认真阅读并同意</span>
        <a class="degree" @click="dialogTableVisible = true">《使用协议》</a>
      </div>
      <div class="more-deal flex flex-align-center">
        <img
          @click="submitFun"
          class="sure-btn"
          :class="{ disabled: loading }"
          :style="{
            opacity: loading ? 0.6 : 1,
            cursor: loading ? 'not-allowed' : 'pointer',
          }"
          src="../../assets/images/login.png"
          alt="注册"
        />
        <div v-if="loading" class="loading-text">注册中...</div>
      </div>
    </div>
    <el-dialog v-model="dialogTableVisible" title="用户注册协议">
      <div class="uesrProtocol">
        <h2>尊敬的用户：</h2>
        感谢您选择使用我们的服务！在注册成为本平台用户之前，请您务必仔细阅读以下条款。本协议阐述了您在使用我们平台过程中需遵守的权利与义务，以及我们对您的承诺与要求。一旦您点击“同意”或“注册”按钮，即视为您已充分理解并完全接受本协议的所有条款，同意按照本协议的规定使用我们的服务。

        <h2>一、总则</h2>
        <p>
          1.1
          本协议双方为本平台（以下简称“平台”）与使用本平台服务的用户（以下简称“用户”）。
        </p>
        <p>
          1.2
          平台有权在必要时修改本协议条款，并在平台上公布。用户在使用服务时，应关注并了解最新协议内容。如用户不同意修改后的协议，应立即停止使用平台服务；继续使用则视为接受修改后的协议。
        </p>
        <p>1.3 平台保留在法律允许范围内对本协议的最终解释权。</p>

        <h2>二、用户资格</h2>
        <p>
          2.1
          用户应具备完全民事行为能力，能够独立承担因使用平台服务而产生的法律责任。若用户为未成年人，应在监护人指导下使用平台服务，并对未成年人的使用行为承担相应责任。
        </p>
        <p>
          2.2
          用户在注册时应提供真实、准确、完整的信息，并在信息变更时及时更新，以免影响服务的正常使用及平台与用户的沟通。
        </p>

        <h2>三、注册流程</h2>
        <p>
          3.1
          用户需按照平台提示，准确填写注册信息，包括但不限于手机号码、电子邮箱、用户名等，并设置安全的登录密码。
        </p>
        <p>
          3.2
          平台可能对注册信息进行验证，如通过发送验证码等方式。用户需按照平台要求完成验证流程，以确保注册信息的真实性和有效性。
        </p>
        <p>
          3.3
          注册成功后，平台将为用户分配一个唯一的账号。该账号及密码由用户自行保管，用户应对使用该账号及密码进行的所有行为负责。
        </p>

        <h2>四、账号管理</h2>
        <p>
          4.1
          用户应妥善保管账号及密码，不得将账号转让、出租或出借给他人使用。因用户保管不善导致账号被盗用或产生其他不良后果的，用户应自行承担相应责任。
        </p>
        <p>
          4.2
          如用户发现账号存在异常情况，如被盗用、密码泄露等，应立即通知平台，并按照平台指引进行账号安全处理。
        </p>
        <p>
          4.3
          平台有权在合理怀疑账号存在安全风险或违反本协议规定的情况下，对账号采取限制措施，如暂停使用、冻结账号等，直至用户按照平台要求完成身份验证或其他相关操作。
        </p>

        <h2>五、用户权利与义务</h2>
        <h3>5.1用户权利</h3>
        <p>
          5.1.1
          用户在遵守本协议及相关法律法规的前提下，有权使用平台提供的各项服务，包括但不限于浏览信息、发布内容、参与互动等。
        </p>
        <p>
          5.1.2
          用户有权对平台服务提出合理的建议和意见，平台将积极予以回应和改进。
        </p>
        <h3>5.2用户义务</h3>
        <p>
          5.2.1
          用户应遵守法律法规、社会公德和本协议的规定，不得利用平台从事违法违规活动，如发布虚假信息、传播有害内容、侵犯他人权益等。
        </p>
        <p>
          5.2.2
          用户应文明使用平台服务，尊重其他用户，不得进行恶意攻击、侮辱、诽谤等行为，维护良好的网络环境。
        </p>
        <p>
          5.2.3
          用户应按照平台规定的方式使用服务，不得进行任何可能对平台服务器、网络或系统造成损害的行为，如恶意刷屏、攻击平台系统等。
        </p>
        <p>
          5.2.4
          用户应保证其发布内容的真实性、合法性，不得侵犯他人的知识产权、隐私权、名誉权等合法权益。如因用户发布内容引发法律纠纷或争议的，用户应自行承担全部法律责任，并赔偿平台因此遭受的损失。
        </p>

        <h2>六、平台权利与义务</h2>
        <h3>6.1平台权利</h3>
        <p>
          6.1.1
          平台有权对用户注册信息及使用服务的行为进行审核和监督，如发现用户违反本协议规定或存在违法违规行为，有权采取相应的措施，包括但不限于警告、限制功能、封禁账号等。
        </p>
        <p>
          6.1.2
          平台有权根据运营需要，在提前通知用户的情况下，对服务内容、功能、规则等进行调整和变更。
        </p>
        <p>
          6.1.3
          对于用户在平台上发布的违法违规或侵权内容，平台有权进行删除、屏蔽等处理，以维护平台的合法权益和社会公共利益。
        </p>
        <h3>6.2平台义务</h3>
        <p>
          6.2.1
          平台应按照法律法规和本协议的规定，为用户提供安全、稳定、可靠的服务，并不断优化和提升服务质量。
        </p>
        <p>
          6.2.2
          平台应采取合理的措施保护用户的个人信息安全，不得非法收集、使用、披露或泄露用户信息。除非法律要求或为提供服务所必需，平台不得向第三方提供用户的个人信息。
        </p>
        <p>
          6.2.3
          平台应及时处理用户反馈和投诉，积极解决用户在使用服务过程中遇到的问题，为用户提供良好的使用体验。
        </p>
        <h2>七、隐私保护</h2>
        <p>
          7.1
          平台尊重用户的隐私权，将按照法律法规和本协议的规定，采取严格的安全措施保护用户的个人信息。
        </p>
        <p>
          7.2
          用户同意平台为提供服务的需要，收集、存储和使用用户的个人信息，包括但不限于注册信息、使用记录、设备信息等。平台将仅在合法、正当、必要的范围内使用用户信息，不会将用户信息用于其他目的。
        </p>
        <p>
          7.3
          除法律法规规定或为保护平台合法权益外，平台在未经用户同意的情况下，不会向第三方披露或共享用户的个人信息。但在以下情况下，平台可能向第三方提供用户信息：<br />
          - 用户事先同意或授权；<br />
          - 根据法律法规要求或司法机关的命令； <br />
          -为维护平台的安全和稳定，防止欺诈或其他非法活动；<br />
          -为保护平台或第三方的合法权益，如涉及知识产权保护等。
        </p>
        <p>
          7.4
          平台将采取合理的安全措施防止用户信息的泄露、丢失、损坏等风险。如发生用户信息安全事件，平台将及时通知用户，并采取相应的补救措施。
        </p>
        <h2>八、法律责任</h2>
        <p>
          8.1
          用户在使用平台服务过程中，因自身行为导致的任何法律后果由用户自行承担。如因用户违反本协议或法律法规给平台造成损失的，用户应承担相应的赔偿责任。
        </p>
        <p>
          8.2
          平台尽力确保服务的安全性和可靠性，但因不可抗力、技术故障、第三方行为等原因导致的服务中断、数据丢失或其他损失，平台不承担赔偿责任，但将尽力采取措施减少用户的损失。
        </p>
        <p>
          8.3
          本协议的订立、执行和解释均适用中华人民共和国法律。如本协议条款与法律法规相抵触，以法律法规为准。如双方在本协议履行过程中发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向有管辖权的人民法院提起诉讼。
        </p>

        <h2>九、其他</h2>
        <p>9.1 本协议自用户注册成功之日起生效，具有法律效力。</p>
        <p>9.2 本协议未尽事宜，双方应按照法律法规和公平合理的原则协商解决。</p>
        <p>
          9.3
          平台可能会针对特定服务制定补充协议或专项规则，用户在使用相关服务时应同时遵守。如补充协议或专项规则与本协议存在冲突，以补充协议或专项规则为准。
        </p>
        <h2>平台名称：UniverseX</h2>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref } from "vue";
import CryptoJS from "crypto-js";
import { register, getCode, checkCode } from "@/api/login.js";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import { phoneReg, passwordReg } from "@/utils/validate";
import { useRouter } from "vue-router";

const $toast = useToast();
const dialogTableVisible = ref(false);
const loading = ref(false);
const codeLoading = ref(false);
// 账号密码错误
const from = ref({
  username: "",
  phone: "",
  code: "",
  password: "",
  checkPassword: "",
});
const rule = ref({
  username: "",
  phone: "",
  code: "",
  password: "",
});
const testFormItem = (key) => {
  switch (key) {
    case "username":
      if (!from.value.username || from.value.username.trim() === "") {
        rule.value.username = "昵称不能为空";
      } else if (from.value.username.trim().length < 2) {
        rule.value.username = "昵称至少2个字符";
      } else if (from.value.username.trim().length > 20) {
        rule.value.username = "昵称不能超过20个字符";
      } else {
        rule.value.username = "";
      }
      break;
    case "phone":
      if (!from.value.phone || from.value.phone.trim() === "") {
        rule.value.phone = "手机号不能为空";
      } else if (!phoneReg.test(from.value.phone)) {
        rule.value.phone = "请输入正确的手机号格式";
      } else {
        rule.value.phone = "";
      }
      break;
    case "password":
      if (!from.value.password || from.value.password.trim() === "") {
        rule.value.password = "密码不能为空";
      } else if (!passwordReg.test(from.value.password)) {
        rule.value.password = "密码须含数字字母且8位以上";
      } else {
        rule.value.password = "";
      }
      break;
    case "code":
      if (!from.value.code || from.value.code.trim() === "") {
        rule.value.code = "验证码不能为空";
      } else if (from.value.code.trim().length !== 6) {
        rule.value.code = "验证码为6位数字";
      } else {
        rule.value.code = "";
      }
      break;

    default:
      break;
  }
};
// 获取验证码
let conutdown = ref(0);
let timer = null;
const clickCode = async () => {
  // 防止重复点击
  if (conutdown.value > 0 || codeLoading.value) {
    return;
  }

  // 验证手机号
  if (!from.value.phone || from.value.phone.trim() === "") {
    $toast.error("请输入手机号", {
      position: "top",
    });
    return;
  }

  // 验证手机号格式
  if (!phoneReg.test(from.value.phone)) {
    rule.value.phone = "请输入正确的手机号格式";
    $toast.error("请输入正确的手机号格式", {
      position: "top",
    });
    return;
  }

  codeLoading.value = true;
  try {
    // 开发环境：使用测试验证码 999999
    const isDevelopment = process.env.NODE_ENV === "development";

    if (isDevelopment) {
      // 开发环境：先调用真实API获取验证码（后端会发送验证码）
      // 但前端显示测试验证码999999供用户使用
      try {
        await getCode({ phone: from.value.phone });
      } catch (error) {
        // 忽略获取验证码的错误，继续使用测试验证码
        console.log("开发环境：使用测试验证码，忽略真实API调用错误");
      }

      // 显示测试验证码提示
      $toast.success("测试验证码：999999（开发环境专用）", {
        position: "top",
        duration: 3000,
      });
      // 自动填充测试验证码
      from.value.code = "999999";
      // 开始倒计时
      conutdown.value = 60;
      timer = setInterval(() => {
        if (conutdown.value > 0) {
          conutdown.value--;
        } else {
          timer && clearInterval(timer);
          timer = null;
        }
      }, 1000);
    } else {
      // 生产环境：调用真实API
      const res = await getCode({ phone: from.value.phone });
      if (res && res.code === 200) {
        $toast.success("验证码已发送，请查收", {
          position: "top",
        });
        // 开始倒计时
        conutdown.value = 60;
        timer = setInterval(() => {
          if (conutdown.value > 0) {
            conutdown.value--;
          } else {
            timer && clearInterval(timer);
            timer = null;
          }
        }, 1000);
      } else {
        $toast.error(res?.message || "获取验证码失败", {
          position: "top",
        });
      }
    }
  } catch (error) {
    console.error("获取验证码失败:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "获取验证码失败，请稍后重试";
    $toast.error(errorMsg, {
      position: "top",
    });
  } finally {
    codeLoading.value = false;
  }
};

// 提交验证
const router = useRouter();
let isCheck = ref(false);

const submitFun = async () => {
  // 防止重复提交
  if (loading.value) {
    return;
  }

  // 检查协议
  if (!isCheck.value) {
    $toast.error("请勾选同意《使用协议》", {
      position: "top",
    });
    return;
  }

  // 表单验证
  const isPass = allReg();
  if (!isPass) {
    $toast.error("请完善表单信息", {
      position: "top",
    });
    return;
  }

  loading.value = true;

  try {
    // 开发环境：如果是测试验证码，跳过校验
    const isDevelopment = process.env.NODE_ENV === "development";
    const isTestCode = from.value.code === "999999";

    if (!isDevelopment || !isTestCode) {
      // 生产环境或非测试验证码：校验验证码
      const checkRes = await checkCode({
        account: from.value.phone,
        code: from.value.code,
      });

      if (!checkRes || checkRes.code !== 200) {
        $toast.error(checkRes?.message || "验证码错误或已过期", {
          position: "top",
        });
        rule.value.code = checkRes?.message || "验证码错误或已过期";
        return;
      }
    }

    // 对密码进行MD5加密
    const registerData = {
      username: from.value.username.trim(),
      phone: from.value.phone.trim(),
      code: from.value.code.trim(),
      password: CryptoJS.MD5(from.value.password).toString(),
      checkPassword: CryptoJS.MD5(from.value.password).toString(),
    };

    const res = await register(registerData);

    if (res && res.code === 200) {
      $toast.success("注册成功，请登录", {
        position: "top",
        duration: 2000,
      });
      // 延迟跳转，让用户看到成功提示
      setTimeout(() => {
        router.push("/login");
      }, 1500);
    } else {
      const errorMsg = res?.message || "注册失败，请稍后重试";
      $toast.error(errorMsg, {
        position: "top",
      });
    }
  } catch (error) {
    console.error("注册失败:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "注册失败，请稍后重试";
    $toast.error(errorMsg, {
      position: "top",
    });
  } finally {
    loading.value = false;
  }
};

const allReg = () => {
  let isPass = true;
  // 验证所有必填字段
  const requiredFields = ["username", "phone", "password", "code"];
  for (const key of requiredFields) {
    testFormItem(key);
    if (rule.value[key]) {
      isPass = false;
    }
  }
  return isPass;
};
</script>
<style lang="scss" scoped>
.user-wrapper {
  min-height: calc(100vh - 193px);
  padding-top: 86px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-page {
  width: 406px;
  margin: 0 auto;
  .title {
    font-size: 48px;
    color: var(--ux-text-primary);
    line-height: 61px;
    margin-bottom: 29px;
    text-align: center;
  }
  .push {
    margin-left: 10px;
    width: 33px;
    height: 33px;
    line-height: 33px;
  }
  .icon {
    width: 100%;
  }
  .more-deal {
    margin-top: 5px;
    justify-content: center;
    position: relative;

    .sure-btn {
      width: 93px;
      height: 93px;
      transition: opacity 0.3s;
      &:hover:not(.disabled) {
        cursor: pointer;
        opacity: 0.8;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .loading-text {
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: #666;
    }
    .more {
      position: absolute;
      right: 18px;
      top: 35px;
    }
    .for,
    .reg {
      font-size: 14px;
      font-family: Zero G Regular-Regular, Zero G Regular;
      font-weight: 400;
      color: var(--ux-text-secondary);
      line-height: 16px;
    }
    .reg {
      margin-top: 10px;
    }
  }
  .error-box {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateX(calc(100% + 27px));
    .error-icon {
      margin-right: 7px;
      width: 33px;
      height: 33px;
    }
    .msg {
      color: #d81e06;
    }
  }
  .argee {
    margin-top: 30px;
    justify-content: center;
    .check {
      border: 0;
      width: 15px;
      height: 15px;
      background: var(--ux-surface-muted);
      margin-right: 7px;
    }
    .read {
      font-size: 14px;
      font-family: ABeeZee-Italic, ABeeZee;
      line-height: 16px;
    }
    .degree {
      font-size: 14px;
      font-family: ABeeZee-Italic, ABeeZee;
      line-height: 16px;
      color: #0473da;
      cursor: pointer;
    }
  }
}

.gray {
  color: #f2f2f2;
  pointer-events: none;
}
/* 设置未选中样式 */
.check[type="checkbox"] {
  position: relative;
  width: 15px;
  height: 15px;
  line-height: 15px;
  border: 1px solid #949494;
  /* 取消默认样式 */
}
.uesrProtocol {
  h2 {
    margin: 20px 0;
    font-size: 26px;
  }
  h3 {
    margin: 20px 0;
    font-size: 22px;
  }
  p {
    margin: 15px 0;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
